import React, { Fragment } from 'react';

import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { localizable } from '../../../components/Localization';

export default localizable('AwardStep4')(
  ({ t, store: { rejectMessage, handleRejectMessageChange } }) => (
    <Fragment>
      <ul className="hint">
        <li>{t('This text will appear as an additional note')}</li>
      </ul>

      <div className="control">
        <TextField
          label={t('Reject message')}
          multiline
          name="ag"
          value={rejectMessage}
          onChanged={handleRejectMessageChange}
        />
      </div>
    </Fragment>
  )
);



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Award/Step4.jsx